import { getTelegramInitData, isTelegramMiniApp } from '../utils/platform';
import { clearBrowserSession } from './sessionStore';

const PUBLIC_AUTH_PATHS = ['/auth/login', '/auth/register', '/auth/refresh', '/auth/telegram'];

function isPublicAuthRequest(url = '') {
  return PUBLIC_AUTH_PATHS.some((path) => url.includes(path));
}

export function attachAuthInterceptors(api, { refreshSession, reauthenticateTelegram }) {
  api.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      return config;
    },
    (error) => Promise.reject(error)
  );

  api.interceptors.response.use(
    (response) => response,
    async (error) => {
      const original = error.config;
      if (error.response?.status !== 401 || !original || original._retry) {
        return Promise.reject(error);
      }
      if (isPublicAuthRequest(original.url || '')) {
        return Promise.reject(error);
      }

      if (isTelegramMiniApp()) {
        original._retry = true;
        const initData = getTelegramInitData();
        if (!initData) {
          localStorage.removeItem('token');
          if (!sessionStorage.getItem('tg-auth-reloaded')) {
            sessionStorage.setItem('tg-auth-reloaded', '1');
            window.location.reload();
          }
          return Promise.reject(error);
        }

        try {
          const accessToken = await reauthenticateTelegram();
          original.headers = original.headers || {};
          original.headers['Authorization'] = `Bearer ${accessToken}`;
          return api(original);
        } catch (authError) {
          localStorage.removeItem('token');
          window.dispatchEvent(new Event('telegram-auth-failed'));
          return Promise.reject(authError);
        }
      }

      original._retry = true;
      try {
        const accessToken = await refreshSession();
        original.headers = original.headers || {};
        original.headers['Authorization'] = `Bearer ${accessToken}`;
        return api(original);
      } catch (refreshError) {
        // refreshSession уже проверил, не обновила ли токен другая вкладка: сессии нет
        clearBrowserSession();
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }
  );
}
